<template>
    <div>
        <b-row class="justify-content-center">
            <h5>{{ labels.title }}</h5>
        </b-row>
        <b-row class="justify-content-center" v-if="listActivos != 0">
            <b-table
                :items="listActivos"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template #cell(nro_contrato)="data">
                    <div class="text-right">{{ data.item.nro_contrato }}</div>
                </template>
                <template #cell(activo)="data">
                    <div class="text-left">{{ tipoActivo(data.item.activo) }}</div>
                </template>
                <template #cell(descripcion)="data">
                    <div class="text-left">{{ nameActivo(data.item.activo) }}</div>
                </template>
                <template #cell(proveedor)="data">
                    <div class="text-left">{{ proveedor(data.item.activo) }}</div>
                </template>
                <template #cell(valor_compra)="data">
                    <div class="text-right">{{ valCompra(data.item.activo) }}</div>
                </template>
                <template #cell(valor_salvamento)="data">
                    <div class="text-right">{{ valSalvamento(data.item.activo) }}</div>
                </template>
                <template #cell(valor_amortizado)="data">
                    <div class="text-right">{{ valAmortizado(data.item.activo) }}</div>
                </template>
                <template #cell(fecha_compra)="data">
                    <div class="text-right">{{ fechaCompra(data.item.activo) }}</div>
                </template>
            </b-table>
            <div class="row col-md-12">
                <div class="col-md-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="listActivos.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-md-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </b-row>
        <b-row class="justify-content-center" v-else>
            <h5>{{ labels.noRow }}</h5>
        </b-row>
    </div>
</template>

<script>
import ContratoActivo from '../../services/ContratoActivo';
import Activos from '../../services/Activos'
import TipoActivo from '../../services/TipoActivo';
import Tercero from '../../services/Tercero';

export default {
    name : 'ActivosContrato',
    props:['numContrato'],
    data:() => ({
        listActivos : [],
        activos : [],
        lstTipoActivo : [],
        lstProveedor : [],
        perPage: 500,
        currentPage: 1,
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'activo', label: 'Tipo activo', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'proveedor', label: 'Proveedor', sortable: false },
            { key: 'valor_compra', label: 'Valor compra', sortable: false },
            { key: 'valor_salvamento', label: 'Valor salvamento', sortable: false },
            { key: 'valor_amortizado', label: 'Valor amortizado', sortable: false },
            { key: 'fecha_compra', label: 'Fecha compra', sortable: false },
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Lista activos',
                    nroContrato : 'Nro. contrato',
                    activos : 'Activos',
                    tipoActivo : 'Tipo Activo',
                    proveedor : 'Proveedor',
                    valorCompra : 'Valor compra',
                    valorSalvamento : 'Valor salvamento',
                    valorAmortizado : 'Valor amortizado',
                    fechaCompra : 'Fecha compra',
                    noRow : "No hay registros",
                }
            }else{
                return {
                    title : 'Active List',
                    nroContrato : 'Contract number',
                    activos : 'Assets',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    valorAmortizado : 'Amortized value',
                    fechaCompra : 'Purchase date',
                    noRow : "There are not records",
                }
            }
        }
    },
    methods:{
        nameActivo(numActivo){
            let name = this.activos.find((activo) => activo.activo == numActivo)
            return name.descripcion
        },
        tipoActivo(numActivo){
            let numTipoActivo = this.activos.find((activo) => activo.activo == numActivo)
            let nameTipoActivo = this.lstTipoActivo.find((tipoAct) => tipoAct.tipo_activo == numTipoActivo.tipo_activo)
            return nameTipoActivo.descripcion
        },
        proveedor(numActivo){
            let numProveedor = this.activos.find(activo => activo.activo == numActivo)
            let nameProveedor = this.lstProveedor.find( prov => prov.identificacion == numProveedor.proveedor)
            return nameProveedor.nombre
        },
        valCompra(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo)
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor.valor_compra)
        },
        valSalvamento(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo)
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor.valor_salvamento)
        },
        valAmortizado(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo)
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor.valor_amortizado)
        },
        fechaCompra(numActivo){
            let fecha = this.activos.find((activo) => activo.activo == numActivo)
            return fecha.fecha_compra
        }
    },
    mounted(){
        ContratoActivo.getActivoContratoByNumContr(this.numContrato)
        .then((res) => {
            // console.log(res.data.activosContrato);
            this.listActivos = res.data.activosContrato
        })
        .catch((err) => console.log(err))

        Activos.getAllActivos()
        .then((res) => {
            // console.log(res.data.listActivos);
            this.activos = res.data.listActivos
        })
        .catch((err) => console.log(err))

        TipoActivo.getAllTipoActivo()
        .then((res) => {
            // console.log(res.data.listTipoActivo);
            this.lstTipoActivo = res.data.listTipoActivo
        })
        .catch((err) => console.log(err))

        Tercero.getAllTercero()
        .then((res) => {
            // console.log(res.data.listTercero);
            this.lstProveedor = res.data.listTercero
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>